import {BehaviorSubject, Subject} from 'rxjs';
import {skipUntil, switchMap, map} from 'rxjs/operators';
import {assetsApi} from '@/api/assets';
import {browser$} from '@/streams/browser';
import {contracts$} from '@/streams/config/contract';

export const query$ = new Subject();
export const supportedCurrencies$ = new BehaviorSubject(createInitCurrencies());

export const contractSupportedConvertCurrencies$ = contracts$.pipe(
  map((contracts) =>
    contracts.reduce((preValue, item) => {
      const {settleCurrency} = item;
      if (preValue.indexOf(settleCurrency) < 0) {
        preValue.push(settleCurrency);
      }
      return preValue;
    }, [])
  )
);

query$
  .pipe(
    skipUntil(browser$),
    switchMap(() => loadConversionSupportedCurrencies())
  )
  .subscribe((x) => supportedCurrencies$.next(x));

async function loadConversionSupportedCurrencies() {
  const query = {cfgType: 'CFG_CURRENCY_PAIR'};
  const {data} = await assetsApi.getConversionSupportedCurrencies(query);
  if (data) {
    return data;
  }
  return createInitCurrencies();
}

function createInitCurrencies() {
  return {
    cfgList: [],
  };
}
